import axios from 'axios';
import { OpenAPI } from '@/infrastructure/api/core/OpenAPI';
import { useAuthStore } from '@/stores/auth';
import router from '@/router';

/**
 * Configures the generated OpenAPI client with application-specific settings.
 * This avoids modifying the generated files directly.
 */
export const setupApi = () => {
  // Configure the token to be retrieved from the auth store for each request
  OpenAPI.TOKEN = async () => {
    const authStore = useAuthStore();
    return authStore.token || '';
  };

  // Global 401 handler: when a token expires (or is otherwise rejected by the
  // backend), clear the auth state and bounce the user to the login page.
  // Failures on the login endpoint itself are left for LoginView to render.
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const requestUrl: string | undefined = error?.config?.url;
      const isLoginRequest = typeof requestUrl === 'string' && requestUrl.includes('/api/login');

      if (status === 401 && !isLoginRequest) {
        const authStore = useAuthStore();
        authStore.logout();

        const current = router.currentRoute.value;
        if (current.name !== 'login') {
          router.push({
            name: 'login',
            query: current.fullPath && current.fullPath !== '/' ? { redirect: current.fullPath } : undefined,
          });
        }
      }

      return Promise.reject(error);
    },
  );

  // Configure other global settings if needed
  // OpenAPI.WITH_CREDENTIALS = true;
};
